import { gql } from "@apollo/client";
import { DistrictFragments } from "../fragments/district";

export const INSERT_DISTRICT = gql`
  mutation insertDistrict($districtInput: DistrictInput) {
    insertDistrict(districtInput: $districtInput) {
      ...DistrictFormFields
    }
  }
  ${DistrictFragments.formFields}
`;

export const UPDATE_DISTRICT = gql`
  mutation updateDistrict($id: ID!, $districtInput: DistrictInput) {
    updateDistrict(id: $id, districtInput: $districtInput) {
      ...DistrictFormFields
      hidden
    }
  }
  ${DistrictFragments.formFields}
`;

export const INSERT_DISTRICT_FORM = gql`
  mutation insertDistrictForm($districtFormInput: DistrictFormInput) {
    insertDistrictForm(districtFormInput: $districtFormInput) {
      id
      formId
      active
      downloadFileName
      allowMultipleInstances
      form {
        id
        formCode
        name
      }
      createdBy
      createdAtAgo
      updatedAtAgo
      createdAt(format: "ddd mmm dd yyyy h:MM:ss TT Z")
      updatedAt(format: "ddd mmm dd yyyy h:MM:ss TT Z")
    }
  }
`;

export const UPDATE_DISTRICT_FORM = gql`
  mutation updateDistrictForm($id: ID!, $districtFormInput: DistrictFormInput) {
    updateDistrictForm(id: $id, districtFormInput: $districtFormInput) {
      id
      formId
      active
      downloadFileName
      allowMultipleInstances
      form {
        id
        formCode
        name
      }
      createdBy
      createdAtAgo
      updatedAtAgo
      createdAt(format: "ddd mmm dd yyyy h:MM:ss TT Z")
      updatedAt(format: "ddd mmm dd yyyy h:MM:ss TT Z")
    }
  }
`;

export const UPDATE_DISTRICT_FORM_PERMISSION = gql`
  mutation updateSubRolePermissionToForm(
    $formSubRolePermissionInput: FormSubRolePermissionInput!
  ) {
    updateSubRolePermissionToForm(
      formSubRolePermissionInput: $formSubRolePermissionInput
    ) {
      id
    }
  }
`;
